var _defs, _polyline, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    width: 24,
    height: 24,
    color: "#22543d",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-637b7f18f95e86b59c579fd2-1{fill:none;stroke:currentColor;stroke-miterlimit:10;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-637b7f18f95e86b59c579fd2-1",
    points: "23.5 22.5 1.5 22.5 1.5 0.5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-637b7f18f95e86b59c579fd2-1",
    x: 6.28,
    y: 11.98,
    width: 4.78,
    height: 10.52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-637b7f18f95e86b59c579fd2-1",
    x: 15.85,
    y: 8.15,
    width: 4.78,
    height: 14.35
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-637b7f18f95e86b59c579fd2-1",
    x: 11.07,
    y: 3.37,
    width: 4.78,
    height: 19.13
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.9ddb4fc0961ee8a51b9b3fe0888fa500.svg";
export { ForwardRef as ReactComponent };